import { useCallback } from 'react';
import { RealtimeAudienceEnum } from 'realtimer/realtimerAudiences';
import { useExpertDataLazyQuery } from 'shared/hooks/api/expertData/expertData.generated';
import { useRecommendedJobOrdersLazyQuery } from 'shared/hooks/api/recommendedJobOrders/recommendedJobOrders.generated';
import { useAuthStore } from 'shared/hooks/stores/useAuthStore';
import { useExpertProfileStore } from 'shared/hooks/stores/useExpertProfileStore';
import { useHubStateStore } from 'shared/hooks/stores/useHubStateStore';
import { useJobOrdersStore } from 'shared/hooks/stores/useJobOrdersStore';
import { useRealtimer } from 'shared/hooks/useRealtimer';
import { ExtractionStateEnum } from 'types/enums/extraction-state.enum';

export const useExpertDataRealtimerEvents = () => {
  const expertId = useAuthStore((state) => state.user?.expertId)!;
  const loadExpertProfile = useExpertProfileStore((state) => state.loadExpertProfile);
  const setOnboardingFinishedAt = useHubStateStore((state) => state.setOnboardingFinishedAt);

  const loadListItems = useJobOrdersStore((store) => store.loadListItems);

  const [getExpertData] = useExpertDataLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const [getRecommendedJobOrders] = useRecommendedJobOrdersLazyQuery({
    fetchPolicy: 'no-cache',
    onCompleted: ({ recommendedJobOrders }) => loadListItems('offers', recommendedJobOrders),
  });

  const handleRealtimerHubStateUpdate = useCallback(async () => {
    const res = await getExpertData();
    const { expertHubData, expertHubState } = res.data ?? {};

    if (expertHubData) {
      loadExpertProfile(expertHubData);
    }
    if (expertHubState) {
      setOnboardingFinishedAt(
        expertHubState.onboardingFinishedAt,
        expertHubState.extractionState as unknown as ExtractionStateEnum,
      );
      if (expertHubState.onboardingFinishedAt) {
        await getRecommendedJobOrders();
      }
    }
  }, [loadExpertProfile]);

  useRealtimer(RealtimeAudienceEnum.HubStateUpdated, { expertId }, handleRealtimerHubStateUpdate);
};
